var BUTTON_GROUP_LABEL_MARGIN = 4;
/* eslint-disable import/prefer-default-export */

export { BUTTON_GROUP_LABEL_MARGIN };
/* eslint-disable import/prefer-default-export */